var modules_b21bc4dc = {"container":"Socials_module_container__6da1ebf6","socials-logo":"Socials_module_socialsLogo__6da1ebf6","socials-block":"Socials_module_socialsBlock__6da1ebf6","socials-icons":"Socials_module_socialsIcons__6da1ebf6","socials-link":"Socials_module_socialsLink__6da1ebf6"};
import "../../assets/BerNC0Z8.css";

export { modules_b21bc4dc as default };
//# sourceMappingURL=Socials.module.less.js.map
